module.exports = __webpack_public_path__ + "img/container_mobile_img.fa401972.png";